/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconFileIsr = createReactComponent("outline", "file-isr", "IconFileIsr", [["path", { "d": "M15 3v4a1 1 0 0 0 1 1h4", "key": "svg-0" }], ["path", { "d": "M15 3v4a1 1 0 0 0 1 1h4", "key": "svg-1" }], ["path", { "d": "M6 8v-3a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-7", "key": "svg-2" }], ["path", { "d": "M3 15l3 -3l3 3", "key": "svg-3" }]]);

export { IconFileIsr as default };
//# sourceMappingURL=IconFileIsr.mjs.map
